/**
 * @generated SignedSource<<921d851308a1fd2440800d32398f04d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashHomeV2Query$data = {
  readonly liveWidget: {
    readonly style: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"superSplashLargeLiveWidget" | "superSplashLiveLiveWidget">;
  } | null | undefined;
  readonly " $fragmentType": "superSplashHomeV2Query";
};
export type superSplashHomeV2Query$key = {
  readonly " $data"?: superSplashHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashHomeV2Query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "edition"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashHomeV2Query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "edition",
              "variableName": "edition"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "UPDATED_DATE"
          }
        }
      ],
      "concreteType": "LiveWidget",
      "kind": "LinkedField",
      "name": "liveWidget",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLiveLiveWidget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLargeLiveWidget"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9a6f92356c8bd2cfcc4086a648b021dd";

export default node;
